import React from 'react';
import styles from './HelpVideo.module.scss';

const HelpVideo = () => {
  return (
    <div>
      <div className={`container`}>
        <div className={`row ${styles.videoContainer}`}>
          <div className={`col-md-6 col-12`}>
            <video controls>
              <source src="/Videos/video.mp4" type="video/mp4" />
            </video>
          </div>
          <div className={`col-md-6 col-12 ${styles.text}`}>
            <h3>We’re here to help</h3>
            <p>
              A death can be a difficult time, and there can be a lot to organise. Watch this short
              video to learn more about how the Australian Death Notification Service can help.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpVideo;
